export default {"src":"/_next/static/media/grad-glow.c0215a61.svg","height":953,"width":960,"blurWidth":0,"blurHeight":0};